import React, { useEffect, useRef, useState } from 'react'

interface CounterProps {
  delay: number
}

const Counter = ({ delay }: CounterProps): JSX.Element => {
  const [counter, setCounter] = useState<number>(delay)
  const intervalRef = useRef<NodeJS.Timeout | null>(null)

  useEffect(() => {
    intervalRef.current = setInterval(() => {
      setCounter((value) => {
        return value ? value - 1 : 0
      })
    }, 1000)

    return () => {
      intervalRef.current && clearInterval(intervalRef.current)
    }
  }, [])

  return counter ? (
    <div
      className='rf-relative rf-h-32 rf-w-32 rf-flex rf-items-center rf-justify-center rf-text-6xl rf-text-primary rf-loader-counter'
      style={
        {
          '--duration': `${delay}s`
        } as React.CSSProperties
      }
    >
      {counter}
    </div>
  ) : (
    <React.Fragment />
  )
}

export default Counter
